export default {
    login: {
        title: 'NFC智能名片',
        welcome: '欢迎登录',
        code: '验证码',
        send: '发送验证码',
        info: '填写个人信息',
        avatar: '头像',
        name: '姓名',
        nameplaceholder: '请输入您的姓名',
        englishName: '英文名',
        englishnameplaceholder: '请输入您的英文名',
        position: '职位',
        positionplaceholder: '请输入您的职位',
        englishposition: '职位英文名',
        visitLinkUrl: '企业微信链接',
        getvis: '获取教程',
        visitplaceholder: '请输入企业微信链接',
        moblie: '电话号码',
        moblieplaceholder: '请输入电话号码',
        email: '邮箱',
        emailplaceholder: '请输入邮箱',
        model1: '数字人显示模式',
        model2: '普通显示模式',
        loginout: '退出登录',
        confirm: '确定',
        codeplaceholder: '请输入验证码',
        noman: '您还没有数字人，请先设置数字人',
        phonemes: '请输入正确的电话号码格式',
        num: 's后重新获取',
        filemes: '文件格式不正确',
        sizemes: '文件过大，请上传小于10MB的文件',
        fillin: '填写联系方式',
        edit: '编辑联系方式'
    },
    home: {
        persentitle: '个人信息',
        set: '设置数字人',
        edit: '编辑',
        call: '联系方式',
        look: '预览名片',
        return: '返回',
        copy: '复制链接',
        copyemail: '邮箱已复制到剪贴板',
        copymes: '复制失败，请手动复制',
        copyphone: '手机号已复制到剪贴板',
        email: '电子邮箱',
        emailcopy: '一键复制电子邮箱',
        phone: '手机号',
        phonecopy: '一键添加手机号',
        link: '企业微信',
        linkcopy: '一键跳转添加好友页面'
    },
    person: {
        title: '设置数字人',
        num: '编号',
        time: '预计完成时间',
        fintime: '完成时间',
        redo: '重做',
        look: '预览',
        add: '添加数字人',
        remaining: '剩余',
        times: "次",
        mes: '生成中，无法预览',
        mes2: '重新提交成功',
        sta1: '已生成',
        sta2: '生成中',
        sta3: '生成失败',
        timeover: '创建数字人次数使用完毕',
        change: '选择卡片风格',
        upload: '上传照片与音色',
        picture: '照片',
        tips: '上传提示',
        tips1: '大小小于10MB',
        tips2: '五官清晰无遮挡',
        tips3: '尽量使用半身照，头部比例太大展示效果相对较差。',
        audio: '录制一段语音以训练AI',
        audiotips1: '您可以自由发挥，也可录制以下内容，时长不低于10s',
        audiotips2: "开始录音。您好，我是[您的名字]。接下来我将为您朗读这段用于语音模型的训练文本。此刻，窗外的天空是一片宁静的蓝色，几朵白云正缓缓飘过。人工智能的技术正在悄然改变我们的生活和工作的方式，它充满了无限的潜力与机遇。",
        hold: '按住录音',
        finshup: '已完成录制采样',
        redo2: '重录',
        text: '输入数字人播报文字',
        textplaceholder: "请输入您需要AI播报的内容，不超过200字",
        textcopy: '粘贴企业播报模板',
        next: '下一步',
        start: '开始生成',
        sizemes: '文件过大，请上传小于10MB的文件',
        uploadmes: '低于10s，请重新录制',
        uploadmes2: '没有录音数据',
        uploadmes3: '录音数据过短，请录制至少10秒',
        uploadmes4: '上传成功',
        uploadmes5: '未完成上传无法进行下一步',
        use: '使用数字人',
        lookperson: '预览数字人',
        lookmes: '使用成功'

    }

}